import { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import imagineHomeService from "../imagineHomeService";
import { DataView, DataViewLayoutOptions } from "primereact/dataview";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { superAdmin } from "../../../lib/constants";
const CompanyOrgnization = () => {
    const [layout, setLayout] = useState("grid");
    const history = useHistory();
    const [searchTradePartner, setSearchTradePartner] = useState("");

    const serviceId = localStorage.getItem("serviceId");
    const [tradePartnersLists, setPartnerLists] = useState([]);

    const userpermissions = JSON.parse(localStorage.getItem("permissions"))
    const isAdmin = (userpermissions.includes(superAdmin))

    const fetchPartnerListsData = async (searchQuery = "") => {
        try {
            const res = await imagineHomeService.getTradePartnerListsData({
                serviceId: serviceId,
                skip: 0,
                limit: 0,
                searchQuery: searchQuery,
            });

            if (res.responseCode === 200) {
                setPartnerLists(res.responseData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const searchTradePartnerHandler = async (e) => {
        setSearchTradePartner(e.target.value);
        fetchPartnerListsData(e.target.value);
    };

    useEffect(() => {
        fetchPartnerListsData();
    }, []);

    const gridItem = (data) => {
        return (
            <div className="col-12 md:col-4 p-2 lg:col-3 flex">
                <div id="" style={{ minWidth: "25%" }} className="flex flex-grow-1">
                    <div onClick={() => history.push(`/edit-trade-partner/${data?._id}`)} className="displayCard designer-card-border p-0 w-full cursor-pointer" id={data._id}>
                        <div className="designerProfilePicture mt-3 mx-auto">
                            <img
                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                src={process.env.REACT_APP_IMAGE_STATIC_URL + "/" + encodeURIComponent(data.image)}
                                alt={`${data.orgLegalName}'s profile`}
                                loading="lazy"
                                onError={(e) => (e.target.src = process.env.REACT_APP_IMAGE_STATIC_URL + "/" + "images/dummy.jpg")}
                            />
                        </div>
                        <div className="flex flex-column mt-2 align-items-center pb-3 px-3">
                            <h3 className="m-0 font-Gerstner-ProgramRegular" style={{ fontSize: "16px", lineHeight: "20px", fontWeight: "600", height: "20px" }}>
                                {data.orgLegalName}
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const itemTemplate = (item, layout) => {
        if (layout === "grid") return gridItem(item);
    };

    const header = () => {
        return (
            <>
                <div className="flex align-items-center justify-content-between flex-wrap mt-1 mb-3">
                    <div className="p-0 lg:col-2 col-12">
                        <h2 className="font-larken m-0 charcoal-color">Trade Partner</h2>
                    </div>
                    <div className="p-0 lg:col-5 col-12">
                        <div className="p-input-icon-right overflow-hidden w-full bg-white designer-card-border" style={{ borderRadius: "2rem" }}>
                            <div className="p-inputgroup">
                                <span className="p-inputgroup-addon bg-white p-2 pr-0" style={{ background: "#FAFAFA" }}>
                                    <i className="pi pi-search text-2xl" style={{ color: "#BFAD5B" }}></i>
                                </span>
                                <InputText value={searchTradePartner} onChange={searchTradePartnerHandler} style={{ background: "#FAFAFA" }} className="bg-white p-2 w-full outline-none" placeholder="Search" />
                            </div>
                        </div>
                    </div>
                    <div className="p-0 lg:col-5 col-12 flex align-items-center justify-content-end" style={{ gap: 10 }}>
                        <div className="p-0">
                            <DataViewLayoutOptions className="custom-layout-options-trade-parnter" layout={layout} onChange={(e) => setLayout(e.value)} />
                        </div>
                        <div className="p-0">
                            <Button
                                onClick={() => history.push(`/add-trade-partner`)}
                                label="ADD TRADE PARTNER"
                                icon="pi pi-plus"
                                className="p-button-rounded p-button-info font-Gerstner-ProgramRegular text-base font-semibold px-4 charcoal-color"
                                style={{ float: "right", letterSpacing: "1.44px", backgroundColor: "#9AAB89 " }}
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    };
    if(!isAdmin) return (<div className="col-12 " style={{ color: "#01579B" }}>
      <div className="card flex flex-column align-items-center justify-content-center dijon-ivory" style={{ height: "60vh"}}>
          <span className="fa-solid fa-circle-info" style={{ fontSize: "3rem" }}></span>
          <h3 className='font-larken'>You are not authorized to access this page</h3>
      </div>
  </div>) 
    return (
        <>
            {layout === "list" && header()}
            {layout === "grid" ? (
                <DataView id={"fu_list_recent_projects"} value={tradePartnersLists} layout={layout} paginator rows={8} itemTemplate={itemTemplate} header={header()} emptyMessage="No Trade Partners Found" />
            ) : (
                <div style={{ border: "1px solid #BFAD5B", borderRadius: "20px" }} className="p-2">
                    <DataTable id="trade-partnerTable" responsiveLayout="scroll" className="w-full" value={tradePartnersLists} paginator rows={8} emptyMessage="No Trade Partners Found">
                        <Column
                            header="Trade Partner Name"
                            field="name"
                            body={(rowData) => (
                                <div className="flex align-items-center">
                                    <img
                                        src={process.env.REACT_APP_IMAGE_STATIC_URL + "/" + encodeURIComponent(rowData.image)}
                                        onError={(e) => (e.target.src = process.env.REACT_APP_IMAGE_STATIC_URL + "/images/dummy.jpg")}
                                        alt={rowData.orgLegalName}
                                        style={{
                                            width: "20px",
                                            height: "20px",
                                            objectFit: "cover",
                                            borderRadius: "50%",
                                        }}
                                    />
                                    <p className="ml-2">{rowData.orgLegalName}</p>
                                </div>
                            )}
                        />
                        <Column bodyClassName="font-Gerstner-ProgramRegular" header="EIN" field="ein" body={(row) => (row.ein ? row.ein : "--")} />
                        <Column bodyClassName="font-Gerstner-ProgramRegular" header="TAN" field="tan" body={(row) => (row.tan ? row.tan : "--")} />
                        <Column bodyClassName="font-Gerstner-ProgramRegular" header="Payment Gateway" field="paymentGateway" body={(row) => (row.paymentGateway ? row.paymentGateway : "--")} />
                        <Column bodyClassName="font-Gerstner-ProgramRegular" header="Merchant ID" field="merchantId" body={(row) => (row.merchantId ? row.merchantId : "--")} />
                        <Column
                            bodyClassName="font-Gerstner-ProgramRegular"
                            header="Manage"
                            body={(rowData) => (
                                <Link style={{ fontFamily: "Montserrat", fontSize: "14px", color: "#47422F" }} to={`/edit-trade-partner/${rowData._id}`} className="underline">
                                    View/Edit
                                </Link>
                            )}
                        />
                    </DataTable>
                </div>
            )}
        </>
    );
};

export default CompanyOrgnization;
